import { DateUtil } from '@/utils';
import mutations from './accKeyListMutation';
import actions from './accKeyListAction';
import getters from './accKeyListGetter';

const state = {
  cnt: 0,
  gridData: {},
  searchParam: {
    divisionCode: '', // 사업부
    cspCode: '', // CSP
    accoutId: '', // Account
    keyAge: '', // Key Age
    uploadDate: null, // 조회일자
  },
  item: {},
  projectList: [],
  columnHeaderList: [], // 컬럼명
  columnNameList: [], // DB 컬럼과 매핑
};

export default {
  state,
  mutations,
  actions,
  getters,
  DateUtil,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/list/accKeyListStore.js